import React, { useEffect, useLayoutEffect } from 'react'
import MapContainer from '../containers/olContainers/MapContainer'
import View from './olComponents/view'
import BaseMap from './olComponents/baseMap'
import ViewContainer from '../containers/PagesContainers/ViewContainer'
import AppButtons from './PagesComponents/AppButtons'
import MapLayers from './LayersComponents/MapLayers'
import useLocalStorage from '../hooks/localStorage/useLocalStorage'
import LoadingPageMapViewContainer from '../containers/PagesContainers/LoadingPageMapViewContainer'

import get from 'lodash/get'

const ViewerApp = props => {
  const {
    isViewerDataLoaded,
    baseMap,
    isModalOpen,
    isTutorial,
    isLoading,
    projection,
    eoxXML,
    view,
    zoomLevel,
    baseMapsSelectedIndex,
    selectBaseMap,
    initializeViewer,
    initializeGlobalLayers,
    initializeViewerGeometries,
    isMapReady,
    isMapZoomReady,
    isGeometriesLoaded,
    isAppReady
  } = props

  const [baseMapIndex, setBaseMapIndex] = useLocalStorage('configBasemapIndex', 0)

  useEffect(() => {
    if (!isViewerDataLoaded) {
      initializeViewer()
      if (baseMapIndex !== baseMapsSelectedIndex) selectBaseMap(baseMapIndex) // dispatch the selection of the basemap with localStorage saved index on initialization
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isViewerDataLoaded])

  useLayoutEffect(() => {
    if (!isMapZoomReady) {
      initializeViewerGeometries()
    }
  }, [isMapZoomReady, initializeViewerGeometries])

  useEffect(() => {
    if (baseMapIndex !== baseMapsSelectedIndex) setBaseMapIndex(baseMapsSelectedIndex) // set localStorage with selected basemap index
  }, [baseMapsSelectedIndex, baseMapIndex, setBaseMapIndex])

  useLayoutEffect(() => {
    if (isGeometriesLoaded && !isMapReady) {
      initializeGlobalLayers()
    }
  }, [isGeometriesLoaded, initializeGlobalLayers, isMapReady])

  return (
    <div id="viewer" className={'ViewerApp ' + (isModalOpen ? 'blur ' : '') + (isTutorial ? 'cursorhelp' : '')}>
      <LoadingPageMapViewContainer />
      {/* A field opened from the dashboard, before the viewer has its own data, waits for it. */}
      {isAppReady && <ViewContainer />}
      <AppButtons visible={isMapReady} />
      <div className={isLoading ? 'blur' : 'loaded-view'}>
        <MapContainer view={<View projection={projection} center={[-3.707398, 40.415363]} />}>
          <BaseMap eoxXML={eoxXML} sources={get(baseMap, 'sources')} key={get(baseMap, 'type')} projection={projection} />
          <MapLayers zoomLevel={zoomLevel} visible={isMapReady} view={view} isMapZoomReady={isMapZoomReady} />
        </MapContainer>
      </div>
    </div>
  )
}

export default ViewerApp
